import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GeliosTextFieldComponent} from './gelios-text-field/gelios-text-field.component';
import {SharedModule} from 'src/app/shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GeliosFieldComponent} from './gelios-field/gelios-field.component';
import {GeliosForeignKeyFieldComponent} from './gelios-foreign-key-field/gelios-foreign-key-field.component';
import {GeliosFieldErrorComponent} from './gelios-field-error/gelios-field-error.component';
import {GeliosFormErrorComponent} from './gelios-form-error/gelios-form-error.component';
import {GeliosImmutableListFieldComponent} from './gelios-immutable-list-field/gelios-immutable-list-field.component';
import {GeliosHiddenFieldComponent} from './gelios-hidden-field/gelios-hidden-field.component';
import {GeliosPasswordFieldComponent} from './gelios-password-field/gelios-password-field.component';
import {GeliosIntegerFieldComponent} from './gelios-integer-field/gelios-integer-field.component';
import {GeliosFloatFieldComponent} from './gelios-float-field/gelios-float-field.component';
import {GeliosBooleanFieldComponent} from './gelios-boolean-field/gelios-boolean-field.component';
import {GeliosDateTimeFieldComponent} from './gelios-datetime-field/gelios-datetime-field.component';
import {GeliosImageFieldComponent} from './gelios-image-field/gelios-image-field.component';
import {GeliosDateFieldComponent} from './gelios-date-field/gelios-date-field.component';
import {GeliosHtmlColorFieldComponent} from './gelios-html-color-field/gelios-html-color-field.component';
import {ColorPickerModule} from 'ngx-color-picker';
import {GeliosSelectFieldComponent} from './gelios-list-box-field/gelios-select-field.component';
import {GeliosAudioFieldComponent} from './gelios-audio-field/gelios-audio-field.component';
import {GeliosMapCoordinateFieldComponent} from './gelios-map-coordinate-field/gelios-map-coordinate-field.component';
import {GeliosTypeaheadFieldComponent} from './gelios-typeahead-field/gelios-typeahead-field.component';
import {GeliosMapPointFieldComponent} from './gelios-map-point-field/gelios-map-point-field.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {GeliosTimeFieldComponent} from './gelios-time-field/gelios-time-field.component';
import {FieldGroupComponent} from '../../app/base/field-group/field-group.component';
import {GeliosDurationDaysFieldComponent} from './gelios-duration-days-field/gelios-duration-days-field.component';
import {GeliosDurationMinutesFieldComponent} from './gelios-duration-minutes-field/gelios-duration-minutes-field.component';
import {GeliosFancyBooleanFieldComponent} from './gelios-fancy-boolean-field/gelios-fancy-boolean-field.component';
import {GeliosInputArrayFieldComponent} from './gelios-input-array-field/gelios-input-array-field.component';
import {BaseFormComponent} from './base-form/base-form.component';
import {GeliosDatetimeRangeFieldComponent} from './gelios-datetime-range-field/gelios-datetime-range-field.component';
import {AgGridModule} from 'ag-grid-angular';
import {GeliosImportFieldComponent} from './gelios-import-field/gelios-import-field.component';
import {GeliosMapUnitCoordinatesFieldComponent} from './gelios-map-unit-coordinates-field/gelios-map-unit-coordinates-field.component';
import {GeliosSwitchBooleanFieldComponent} from './gelios-switch-boolean-field/gelios-switch-boolean-field.component';
import {GeliosRowSelectionFieldComponent} from './gelios-row-selection-field/gelios-row-selection-field.component';
import {DragArrayFieldComponent} from './drag-array-field/drag-array-field.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {GeliosVariationArrayFieldComponent} from './gelios-variation-array-field/gelios-variation-array-field.component';
import {DragPopoverComponent} from './drag-array-field/drag-popover/drag-popover.component';
import {GeliosTemplateDataComponent} from './gelios-template-data/gelios-template-data.component';
import {GeliosObjectFieldComponent} from './gelios-object-field/gelios-object-field.component';
import {GeliosPermissionListFieldComponent} from './gelios-permission-list-field/gelios-permission-list-field.component';
import {GeliosInfoDataComponent} from './gelios-info-data/gelios-info-data.component';
import {GeliosArrayColumnFieldComponent} from './gelios-array-column-field/gelios-array-column-field.component';
import {
  GeliosGridColumnRowSelectionFieldComponent
} from './gelios-grid-column-row-selection-field/gelios-grid-column-row-selection-field.component';

@NgModule({
  declarations: [
    GeliosTextFieldComponent,
    GeliosIntegerFieldComponent,
    GeliosFloatFieldComponent,
    GeliosFieldComponent,
    GeliosForeignKeyFieldComponent,
    GeliosImmutableListFieldComponent,
    GeliosHiddenFieldComponent,
    GeliosPasswordFieldComponent,
    GeliosBooleanFieldComponent,
    GeliosFancyBooleanFieldComponent,
    GeliosDateTimeFieldComponent,
    GeliosImageFieldComponent,
    GeliosFieldErrorComponent,
    GeliosFormErrorComponent,
    GeliosDateFieldComponent,
    GeliosDatetimeRangeFieldComponent,
    GeliosTimeFieldComponent,
    GeliosHtmlColorFieldComponent,
    GeliosSelectFieldComponent,
    GeliosAudioFieldComponent,
    GeliosMapCoordinateFieldComponent,
    GeliosMapPointFieldComponent,
    GeliosTypeaheadFieldComponent,
    GeliosDurationDaysFieldComponent,
    GeliosDurationMinutesFieldComponent,
    GeliosInputArrayFieldComponent,
    FieldGroupComponent,
    BaseFormComponent,
    GeliosImportFieldComponent,
    GeliosMapUnitCoordinatesFieldComponent,
    GeliosSwitchBooleanFieldComponent,
    GeliosRowSelectionFieldComponent,
    DragArrayFieldComponent,
    GeliosVariationArrayFieldComponent,
    DragPopoverComponent,
    GeliosTemplateDataComponent,
    GeliosObjectFieldComponent,
    GeliosPermissionListFieldComponent,
    GeliosInfoDataComponent,
    GeliosArrayColumnFieldComponent,
    GeliosGridColumnRowSelectionFieldComponent,
  ],
  exports: [
    GeliosTextFieldComponent,
    GeliosIntegerFieldComponent,
    GeliosFloatFieldComponent,
    GeliosFieldComponent,
    GeliosForeignKeyFieldComponent,
    GeliosImmutableListFieldComponent,
    GeliosHiddenFieldComponent,
    GeliosPasswordFieldComponent,
    GeliosBooleanFieldComponent,
    GeliosFancyBooleanFieldComponent,
    GeliosDateTimeFieldComponent,
    GeliosImageFieldComponent,
    GeliosFieldErrorComponent,
    GeliosFormErrorComponent,
    GeliosDateFieldComponent,
    GeliosTimeFieldComponent,
    GeliosHtmlColorFieldComponent,
    GeliosSelectFieldComponent,
    GeliosAudioFieldComponent,
    GeliosMapCoordinateFieldComponent,
    GeliosMapPointFieldComponent,
    GeliosTypeaheadFieldComponent,
    GeliosDurationDaysFieldComponent,
    GeliosDurationMinutesFieldComponent,
    GeliosInputArrayFieldComponent,
    FieldGroupComponent,
    BaseFormComponent,
    GeliosSwitchBooleanFieldComponent,
    GeliosTemplateDataComponent,
    GeliosObjectFieldComponent,
    GeliosPermissionListFieldComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerModule,
    LeafletModule,
    AgGridModule,
    DragDropModule,
  ]
})
export class GeliosFieldModule {
}
